const SuperAdmin = 1;
const OrganisationAdmin = 2;
const OrganisationUser = 3;

export { SuperAdmin, OrganisationAdmin, OrganisationUser };
